import styled from 'styled-components';
import {
  Actionbar as CFActionbar,
  TextInput as CFTextInput,
  Flexbox,
  SingleSelect as CFSingleSelect
} from '@ibinder/ui-common-core';

export const Actionbar = styled(CFActionbar)<{ hideBorderTop?: boolean }>`
  ${({ hideBorderTop }) =>
    hideBorderTop &&
    `
    border-top: none;
  `}
  & > menu {
    padding: 0;
    font-weight: bold;
    font-size: ${({ theme }) => theme.fontStyles.smallFont.fontSize}px;
  }
`;

export const Form = styled(Flexbox)`
  margin-top: 1rem;
  width: 100%;
  gap: 2rem;

  @media (max-width: ${({ theme }) => theme.devices.sm}px) {
    flex-direction: column;
  }
`;

export const Col = styled(Flexbox)<{ gap?: number }>`
  width: 100%;
  flex-direction: column;
  gap: ${({ gap }) => gap ?? 1}rem;
`;

export const Row = styled(Flexbox)<{ gap?: number }>`
  gap: ${({ gap }) => gap ?? 1}rem;
`;

export const FormFieldText = styled(CFTextInput)<{ width: string }>`
  width: ${({ width }) => width ?? '100%'};
  & input {
    width: 100%;
  }
  & label {
    font-size: ${({ theme }) => theme.fontStyles.smallFont.fontSize}px;
    color: ${({ theme }) => theme.colors.discrete70};
  }
`;

export const Select = styled(CFSingleSelect)`
  width: 100%;
`;

export const SelectContainer = styled(Flexbox)`
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
`;

export const NumberInput = styled(CFTextInput)`
  width: 3.5rem;
  input {
    text-align: center;
  }
`;

export const PaddingContainer = styled.div`
  padding: 0 1.5rem;
`;

export const MarginContainer = styled.div<{ margin?: number }>`
  margin-top: ${({ margin }) => margin ?? 2}rem;
`;

export const LabelReq = styled.span<{ required?: boolean }>``;
